<template>
  <div class="accordion-list-item" :style="listItemStyle">
    <div
      class="accordion-list-item__main"
      :class="{ open: isExpend }"
      :style="itemTitleSecStyle"
      style="margin-bottom: 1px"
      @click.stop="toggleExpand('title')"
    >
      <lego-checkbox
        v-if="check"
        :indeterminate="indeterminate"
        :readonly="readonly"
        v-model="checked"
        class="list-item__check"
      />
      <lego-radio
        v-else-if="radio"
        v-model="checked"
        :readonly="readonly"
        class="list-item__check"
      />
      <div class="item-title-sec">
        <slot name="title"> {{ title }}</slot>
      </div>
      <div
        v-if="expandable"
        class="expand-icon"
        :class="{ open: isExpend }"
        @click.stop="toggleExpand"
      >
        <lego-icon iconType="df" :size="16">{{ iconName }}</lego-icon>
      </div>
    </div>
    <div v-if="isExpend" class="accordion-list-item__expand">
      <slot name="expand"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'legoAccordionItem',
  props: {
    radio: { type: Boolean, default: undefined },
    check: { type: Boolean, default: undefined },
    titleHeight: {
      type: Number,
      default: 40
    },
    title: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: 'arrow_down'
    },
    value: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    expand: {
      type: Boolean,
      default: false
    },
    readonly: { type: Boolean, default: false },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      checked: false,
      isExpend: false
    };
  },
  watch: {
    checked(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.checked = val;
    },
    expand(val) {
      this.isExpend = val;
    }
  },
  computed: {
    itemTitleSecStyle() {
      return {
        height: `${this.titleHeight}px`
      };
    }
  },
  mounted() {
    this.checked = this.value;
    if (this.index == 0) {
      this.isExpend = true;
      // this.expand = true;
    }
    // this.isExpend = this.expand;
  },
  methods: {
    toggleExpand() {
      this.isExpend = !this.isExpend;
      this.$emit('toggle', this.isExpend);
      this.$emit('scrollIntoView');
    },
    clearExpand() {
      this.isExpend = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.accordion-list-item {
  border: 1px solid $color--ui08;
  background-color: $color--ui-white;

  & + .accordion-list-item {
    margin-top: 6px;
  }

  &__main {
    display: flex;
    align-items: center;
    padding: 0 8px 0 16px;
    cursor: pointer;

    &:hover {
      .item-title-sec {
        color: $color--primary;
      }
      :deep .lego-icon {
        color: $color--primary;
      }
    }

    .lego-checkbox,
    .lego-radio {
      flex: none;
      margin-right: 8px;

      &:hover {
        & + .item-title-sec {
          color: inherit;

          :deep & + .expand-icon {
            .lego-icon {
              color: rgba($color--ui01, 0.6);
            }
          }
        }
      }
    }

    .item-title-sec {
      flex: 1 1 auto;
      @include font(14px);
    }

    .expand-icon {
      cursor: pointer;
      padding: 10px;

      :deep .lego-icon {
        vertical-align: middle;
      }

      :deep &.open {
        .lego-icon {
          transform: rotate(-180deg);
        }
      }
    }
  }

  &__expand {
    border-top: 1px solid $color--ui08;
    margin: 0 20px;
    padding: 8px 12px;
  }
}
</style>
